import { EPIC_ID_PREFIX, STORY_ID_PREFIX, TASK_ID_PREFIX } from '../common';

const getNumericId = (value: string) => {
  const match = value.match(/_(\d+)$/);
  return match ? parseInt(match[1], 10) : 0;
};

export const sortStoriesWithId = (stories: string[]) => {
  const getPrefixRank = (value: string) => {
    if (value.startsWith(STORY_ID_PREFIX)) return 0;
    if (value.startsWith(TASK_ID_PREFIX)) return 1;
    return 2;
  };

  return stories.sort((a, b) => {
    const prefixDiff = getPrefixRank(a) - getPrefixRank(b);
    if (prefixDiff !== 0) return prefixDiff;
    return getNumericId(a) - getNumericId(b);
  });
};

export const sortEpicsWithId = (epicIds: string[]) => {
  return epicIds.slice().sort((a, b) => {
    // Only sort epics with the epic prefix by their numeric ID
    const aIsEpic = a.startsWith(EPIC_ID_PREFIX);
    const bIsEpic = b.startsWith(EPIC_ID_PREFIX);
    
    // Non-epic IDs go to the end
    if (aIsEpic && !bIsEpic) return -1;
    if (!aIsEpic && bIsEpic) return 1;
    if (!aIsEpic && !bIsEpic) return 0;
    
    return getNumericId(a) - getNumericId(b);
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ThrottleFunctionType = (...args: any[]) => void;
type Timer = ReturnType<typeof setTimeout>;
export function useThrottle<Func extends ThrottleFunctionType>(func: Func, delay: number) {
  let timer: Timer | null;
  const throttleFunction = ((...args) => {
    if (timer) {
      return;
    }
    timer = setTimeout(() => {
      func(...args);
      timer = null;
    }, delay);
  }) as Func;
  return throttleFunction;
}
